// extracted by mini-css-extract-plugin
export default {"container":"Card_container__hHT7m","card":"Card_card__o1Nwf","body":"Card_body__2BDNy","image":"Card_image__kQw+m","title":"Card_title__4eAeV","content":"Card_content__anbVU"};